'use client'

import Image from 'next/image'
import s from './style.module.scss'
import useSearch from './use-search'
import {useScrollLock} from '@app/hooks/use-scroll-lock'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import useSearchStore from '../store/search-store'

type Props = {
  placeholderText: string
}

const SearchBar = ({placeholderText}: Props) => {
  const {setFocused} = useSearchStore()
  const {showSearchBtn, handleSearch, resetSearch} = useSearch()
  const {lockScroll, unlockScroll} = useScrollLock()

  lockScroll()

  const onBackClick = () => {
    setFocused(false)
    resetSearch()
    unlockScroll()
    triggerAnalytics('search-btn-closed').sendAll()
  }

  return (
    <form className={s.search_bar_container} onReset={resetSearch}>
      <button type='button' onClick={onBackClick} aria-label='back button' className={s.back_arrow}>
        <Image src='https://static.gamezop.com/comet/assets/img2/back.svg' alt='back button' width={30} height={30} />
      </button>

      <div className={s.search_bar}>
        {/* left search section */}
        <div className={s.search_bar_left_container}>
          {showSearchBtn && (
            <Image
              src='https://static.gamezop.com/comet/assets/img2/search.svg'
              alt='search button'
              width={14}
              height={14}
              className={s.search_icon}
            />
          )}
          <input
            type='search'
            placeholder={placeholderText}
            className={s.search_bar_input}
            onChange={handleSearch}
            autoFocus
          />
        </div>

        {/* right search section */}
        {!showSearchBtn && (
          <button className={s.clear_button} type='reset'>
            <Image
              src='https://static.gamezop.com/comet/assets/img2/close.svg'
              alt='close button'
              width={9}
              height={9}
              className={s.search_icon}
            />
          </button>
        )}
      </div>
    </form>
  )
}

export default SearchBar
